import ConfirmModal from '../../common/ConfirmModal';

interface SendReminderModalProps {
  fullName: string;
  isModalOpen: boolean;
  onClose: () => void;
  action: () => void;
}

export const SendReminderModal = ({
  fullName,
  isModalOpen,
  onClose,
  action,
}: SendReminderModalProps) => {
  return (
    <ConfirmModal
      title={`再招待メール送信`}
      btitle='送信'
      description={`${fullName}さんに再度招待メールを送信します。
よろしいですか？`}
      show={isModalOpen}
      onClose={onClose}
      action={action}
    />
  );
};
